import React, { useState, useEffect, useMemo } from "react"
import { useDispatch, useSelector } from "react-redux"
import { UserStorage } from "utils/userStorage"
import { TOOLS, PLOTTYPE } from "../logic/chartConfig"
import { changeTools } from "redux/ducks/Chart"
import ChartColorSettingModal from "./ChartColorSettingModal"
import { setTools } from "../logic/chartTools"
import _ from "lodash"
import ClassNames from "classnames"
import colorConfig from "styles/image/icon/chart/colorConfig.png"
import colorConfig_bright from "styles/image/icon/chart/colorConfig_bright.png"
import { resetUiSpan } from "components/atoms/chart/logic/chartSpan"

interface props {
  canvasId: string
  infoDialogVisible?: boolean
  setInfoDaialogVisible?: Function
  themeColorFlag?: boolean
  changeThemeColorFlag?: Function
}

const ChartToolButtons = React.memo((props: props) => {
  const { canvasId, infoDialogVisible, setInfoDaialogVisible } = props
  const dispatch = useDispatch()
  const plotTypeSelector = (state: any) => state.chart[canvasId].plotType
  const providersSelector = (state: any) => state.chart[canvasId].providers
  const toolsSelector = (state: any) => state.chart[canvasId].tools
  const plotType = useSelector(plotTypeSelector)
  const providers = useSelector(providersSelector)
  const tools = useSelector(toolsSelector)
  const [_provider, _controller, _procs] = providers
  const [baseColor, changeBaseColor] = useState(
    document.querySelector("html").classList
  )
  const [selectedTools, setSelectedTools] = useState(
    (() => {
      let selectedTools: Array<number> = []
      _.forEach(tools, items => {
        if (TOOLS[4].id !== items.id) selectedTools.push(items.id)
      })
      return selectedTools
    })()
  )
  const [isVisible, setVisible] = useState(false)
  const PandFFlag = useMemo(() => {
    return plotType.id === PLOTTYPE[3].id
  }, [plotType])

  const changeSelectedTools = (id: number) => {
    const _selectedTools: Array<number> = _.clone(selectedTools)
    if (_.includes(selectedTools, id)) {
      _.pull(_selectedTools, id)
      if (id === TOOLS[8].id) setInfoDaialogVisible(false)
      if (id === TOOLS[4].id) resetUiSpan(canvasId, _controller)
    } else {
      _selectedTools.push(id)
      if (id === TOOLS[8].id) setInfoDaialogVisible(true)
    }
    // PandFの場合、クロスカーソルのみ追加・削除できる。
    // それ以外は、dispatchしないため、オンオフの切り替えはできるが、PandFの画面には表示されない。
    if (!PandFFlag) {
      dispatch(changeTools(canvasId, _selectedTools))
    } else {
      if (_.includes(_selectedTools, TOOLS[0].id))
        dispatch(changeTools(canvasId, [TOOLS[0].id]))
      if (!_.includes(_selectedTools, TOOLS[0].id))
        dispatch(changeTools(canvasId, []))
    }
    setSelectedTools(_selectedTools)
  }

  useEffect(() => {
    if (props.themeColorFlag) {
      changeBaseColor(document.querySelector("html").classList)
      props.changeThemeColorFlag(false)
    }
  }, [props.themeColorFlag])

  useEffect(() => {
    if (!_controller) return
    let _selectedTools: Array<number> = []
    _.forEach(tools, items => {
      _selectedTools.push(items.id)
    })
    if (!PandFFlag) setSelectedTools(_selectedTools)
    setTools(tools, plotType.key, _controller)
  }, [tools])

  useEffect(() => {
    if (!_controller || _.isEmpty(selectedTools)) return
    if (_.includes(selectedTools, TOOLS[8].id)) setInfoDaialogVisible(true)
    setTools(tools, plotType.key, _controller)
  }, [_controller])

  // useEffect(() => {
  //   if (_.includes(selectedTools, TOOLS[8].id)) setInfoDaialogVisible(true)
  //   if (!_.includes(selectedTools, TOOLS[8].id)) setInfoDaialogVisible(false)
  // }, [selectedTools])

  useEffect(() => {
    if (!_controller) return
    const _selectedTools = _.clone(selectedTools)
    if (infoDialogVisible && !_.includes(selectedTools, TOOLS[8].id))
      _selectedTools.push(TOOLS[8].id)
    if (!infoDialogVisible && _.includes(selectedTools, TOOLS[8].id))
      _.pull(_selectedTools, TOOLS[8].id)
    setSelectedTools(_selectedTools)
  }, [infoDialogVisible])

  useEffect(() => {
    if (_.isEmpty(selectedTools) || PandFFlag) return
    dispatch(changeTools(canvasId, selectedTools))
  }, [PandFFlag])

  useEffect(() => {
    const _selectedItems = _.clone(selectedTools)
    if (_.includes(selectedTools, TOOLS[4].id))
      _.pull(_selectedItems, TOOLS[4].id)
    setSelectedTools(_selectedItems)
  }, [plotType])

  return (
    <div className="tech-chart-buttons filter-control-item">
      {_.map(TOOLS, items => {
        return (
          <div
            key={items.id}
            title={items.displayTitle}
            className="btn-multi-control"
          >
            <div>
              <label
                className={ClassNames("btn btn-outline shaped", {
                  active: _.includes(selectedTools, items.id),
                  disabled: items.id !== TOOLS[0].id && PandFFlag,
                })}
              >
                <input
                  type="checkbox"
                  className="input-multi-control"
                  onChange={() => changeSelectedTools(items.id)}
                  checked={_.includes(selectedTools, items.id)}
                />
                <img
                  src={
                    _.includes(baseColor, "dark") ||
                    _.includes(selectedTools, items.id)
                      ? items.icon_dark
                      : items.icon
                  }
                  alt={items.displayTitle}
                />
              </label>
            </div>
          </div>
        )
      })}
      <div title="カラー設定" className="btn-multi-control">
        <div>
          <label
            className={ClassNames("btn btn-outline shaped", {
              active: isVisible,
            })}
          >
            <input
              type="checkbox"
              className="input-multi-control"
              onChange={() => setVisible(true)}
              checked={isVisible}
            />
            <img
              src={
                _.includes(baseColor, "dark") ? colorConfig : colorConfig_bright
              }
              alt={"カラー設定"}
            />
          </label>
        </div>
      </div>
      {isVisible && (
        <ChartColorSettingModal
          canvasId={canvasId}
          isVisible={isVisible}
          setVisible={setVisible}
        />
      )}
    </div>
  )
})

export default ChartToolButtons
